import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { DeliveryDetailModal } from '../components/DeliveryDetailModal/DeliveryDetailModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win.
 */
export const NOTIFICATION_MODALS = {
  DELIVERY_DETAIL: 'notifications.delivery-detail',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * **The template editor is deliberately not here.** It is a page, because the
 * live preview beside it must follow the form's own content-language tab — the
 * `locale`/`onLocaleChange` seam `DynamicForm` grew for the question editor —
 * and a preview panel needs room a dialog does not have beside its fields.
 *
 * The one dialog is opened by **string**, so no list imports it (W2), and its
 * payload is an id plus one flag: `refusedRetry`, set when a 409 opened it, so
 * the refusal is explained by the row's own state rather than by a toast that
 * disappears (P19b). `ModalData` is serializable-only, which is why the flag
 * travels rather than a callback.
 */
export const notificationsModals: readonly ModalRegistration[] = [
  { modalTypes: [NOTIFICATION_MODALS.DELIVERY_DETAIL], component: DeliveryDetailModal },
];
